import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "../../ui/sheet";
import { MONTHS, fmtSEK, g } from "./format";

export default function TmDrilldownSheet({ month, year, data, onClose }) {
  const navigate = useNavigate();
  const closed = month && g(data?.periods, month)?.status === "CLOSED";

  return (
    <Sheet open={!!month} onOpenChange={(v) => !v && onClose()}>
      <SheetContent className="w-[620px] sm:max-w-[620px] overflow-y-auto" data-testid="tm-drilldown-panel">
        <SheetHeader>
          <SheetTitle className="font-heading">
            Time & Material — {month ? MONTHS[month - 1] : ""} {year}
          </SheetTitle>
          <SheetDescription>
            {closed ? "Verified actual — contributing assignments" : "Current forecast — contributing assignments"}
          </SheetDescription>
        </SheetHeader>
        {month && (
          <div className="mt-5" data-testid="tm-drilldown-content">
            <table className="w-full">
              <thead>
                <tr className="bg-secondary/50 border-b border-slate-200">
                  <th className="text-left text-xs font-semibold text-slate-500 uppercase py-2 px-3">Consultant / Assignment</th>
                  <th className="text-right text-xs font-semibold text-slate-500 uppercase py-2 px-3">Hours</th>
                  <th className="text-right text-xs font-semibold text-slate-500 uppercase py-2 px-3">Rate</th>
                  <th className="text-right text-xs font-semibold text-slate-500 uppercase py-2 px-3">Amount</th>
                </tr>
              </thead>
              <tbody>
                {(g(data?.months, month)?.tm?.entries || []).map((e) => (
                  <tr key={e.assignment_id} className="border-b border-slate-100" data-testid={`tm-entry-${e.assignment_id}`}>
                    <td className="py-2 px-3 text-sm text-slate-800">{e.consultant_name} / {e.assignment_name}</td>
                    <td className="py-2 px-3 text-right text-sm text-slate-700">
                      {closed ? (e.actual_billed_hours ?? "—") : e.billable_hours}
                    </td>
                    <td className="py-2 px-3 text-right text-sm text-slate-700">{fmtSEK(e.hourly_sales_rate)}</td>
                    <td className="py-2 px-3 text-right text-sm font-semibold text-slate-900">
                      {fmtSEK(closed ? e.actual_revenue : e.forecast_revenue)}
                    </td>
                  </tr>
                ))}
                <tr className="border-t-2 border-slate-300">
                  <td className="py-2 px-3 text-sm font-bold text-slate-900">Total</td>
                  <td colSpan={2} />
                  <td className="py-2 px-3 text-right text-sm font-extrabold text-slate-900" data-testid="tm-drilldown-total">
                    {fmtSEK(g(data?.months, month)?.tm?.value)}
                  </td>
                </tr>
              </tbody>
            </table>
            <Button
              variant="outline"
              className="mt-4"
              onClick={() => navigate("/planning/resource-planning")}
              data-testid="open-resource-planning-link"
            >
              Open Resource Planning <ArrowRight className="h-4 w-4 ml-1.5" />
            </Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
